'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const formatByte = require('./format-byte.cjs');
const formatNumber = require('./format-number.cjs');
const format = require('./format.cjs');



exports.FormatByte = formatByte.FormatByte;
exports.FormatNumber = formatNumber.FormatNumber;
exports.Format = format;
